<template>
  <div class="row">
    <div class="col-12">
      <content-title-block
          :id="$route.params.id"
          :editable="false"
          :value="$store.getters.getUserName(userId)"
          icon="user"
          store-name="User"
      />
    </div>
    <div class="col-12 col-lg-4 col-xxl-5">
      <div v-if="$store.getters.isSuperAdmin" class="mb-4">
        <select v-model="blocked" class="custom-select border-radius mb-2" @change="updateUser('blocked')">
          <option :value="true">blocked</option>
          <option :value="false">unblocked</option>
        </select>
        <div class="vform-label white mb-0 pb-0 mt-2">{{ $t('Home Organization') }}</div>
        <select v-model="homeOrganizationId" class="custom-select border-radius mt-2"
                @change="updateUser('homeOrganizationId')">
          <option v-for="org in $store.getters.getOrganizations" :key="org.id" :value="org.id">{{
              org.displayName
            }}
          </option>
        </select>
      </div>
      <slot/>
      <h2>{{ $t('personalData') }}</h2>
      <div v-if="error" class="form-error p-2">{{ error }}</div>
      <label-with-edit-icon-and-content
          v-if="!isEditing('name')"
          :make-placeholder-space="false"
          :value="name"
          label="name"
          @edit="setEditing('name')"
      />
      <div v-if="isEditing('name')">
        <input
            v-model="name"
            :class="['form-text', $v.name.$error ? 'form-group--error' : '']"
            type="text"
            @blur="$v.name.$touch"
        >
        <div class="edit-trigger mr-2" @click="cancelEditing()">
          <icon :type="'times'"/>
        </div>
        <div class="edit-trigger" @click="updateUser('name')">
          <icon :type="'save'"/>
        </div>
        <div v-if="!$v.name.minLength" class="form-error">
          {{ $t('errors.atLeastCharacters', {num: 3}) }}
        </div>
      </div>
      <label-with-edit-icon-and-content
          v-if="!isEditing('email')"
          :make-placeholder-space="false"
          :value="email"
          class="mb-2"
          label="email"
          @edit="setEditing('email')"
      />
      <div v-if="isEditing('email')">
        <input
            v-model="email"
            :class="['form-text', $v.email.$error ? 'form-group--error' : '']"
            type="text"
            @blur="$v.email.$touch"
        >
        <div class="edit-trigger mr-2" @click="cancelEditing()">
          <icon :type="'times'"/>
        </div>
        <div class="edit-trigger" @click="updateUser('email')">
          <icon :type="'save'"/>
        </div>
        <div v-if="!$v.email.email" class="form-error">{{ $t('errors.mustBeAValidEmailAdress') }}</div>
        <div v-if="!$v.email.isUnique" class="form-error">{{ $t('errors.emailAddressAlreadyExists') }}</div>
      </div>
      <label-with-edit-icon-and-content
          v-if="!isEditing('firstName')"
          :make-placeholder-space="false"
          :value="firstName"
          label="firstName"
          @edit="setEditing('firstName')"
      />
      <div v-if="isEditing('firstName')">
        <input
            v-model="firstName"
            :class="['form-text', $v.firstName.$error ? 'form-group--error' : '']"
            type="text"
            @blur="$v.firstName.$touch"
        >
        <div class="edit-trigger mr-2" @click="cancelEditing()">
          <icon :type="'times'"/>
        </div>
        <div class="edit-trigger" @click="updateUser('firstName')">
          <icon :type="'save'"/>
        </div>
        <div v-if="!$v.firstName.minLength" class="form-error">
          {{ $t('errors.atLeastCharacters', {num: 3}) }}
        </div>
      </div>
      <label-with-edit-icon-and-content
          v-if="!isEditing('lastName')"
          :make-placeholder-space="false"
          :value="lastName"
          class="mb-2"
          label="lastName"
          @edit="setEditing('lastName')"
      />
      <div v-if="isEditing('lastName')">
        <input
            v-model="lastName"
            :class="['form-text', $v.lastName.$error ? 'form-group--error' : '']"
            type="text"
            @blur="$v.lastName.$touch">
        <div class="edit-trigger mr-2" @click="cancelEditing()">
          <icon :type="'times'"/>
        </div>
        <div class="edit-trigger" @click="updateUser('lastName')">
          <icon :type="'save'"/>
        </div>
        <div v-if="!$v.lastName.minLength" class="form-error">
          {{ $t('errors.atLeastCharacters', {num: 3}) }}
        </div>
      </div>


      <div v-if="($store.getters.isSuperAdmin || $store.getters.getCurrentUserHomeOrg === homeOrganizationId)">
        <label-with-edit-icon-and-content
            v-if="!isEditing('password')"
            :is-password="true"
            :value="password"
            label="password"
            @edit="setEditing('password')"
        />
        <div v-if="isEditing('password')" class="darker p-3">
          <div class="w-100">
            <label class="mt-3">{{ $t('newPassword') }}*</label>
            <input
                v-model="password"
                :class="['form-text mb-1', $v.password.$error ? 'form-group--error' : '']"
                :type="showPassword ? 'text' : 'password'"
                @blur="$v.password.$touch"
            >
            <input v-model="showPassword" type="checkbox"/>{{ $t('showPassword') }}
            <password-checker :password="password"/>
          </div>
          <div class="w-100">
            <label class="mt-3">{{ $t('repeatPassword') }}*</label>
            <input v-model="password2"
                   :class="['form-text mb-1', $v.password2.$error ? 'form-group--error' : '']"
                   type="password"
                   @blur="$v.password2.$touch"
            >
            <div v-if="$v.password2.$error" class="form-error">{{ $t('errors.bothPasswordsMustBeTheSame') }}</div>
          </div>
          <div class="d-flex mt-3">
            <div class="edit-trigger mr-2 clickable" @click="cancelEditing()">
              <icon :type="'times'"/>
            </div>
            <div class="edit-trigger clickable" @click="updateUser('password')">
              <icon :type="'save'"/>
            </div>
          </div>
        </div>
      </div>
      <label-with-edit-icon-and-content
          v-if="!isEditing('appPanel')"
          :make-placeholder-space="false"
          :value="appPanel"
          label="appPanel"
          @edit="setEditing('appPanel')"
      />
      <div v-if="isEditing('appPanel')">
        <input
            v-model="appPanel"
            :class="['form-text', $v.email.$error ? 'form-group--error' : '']"
            placeholder="trest"
            type="text"
        >
        <div class="edit-trigger mr-2" @click="cancelEditing()">
          <icon :type="'times'"/>
        </div>
        <div class="edit-trigger" @click="updateUser('appPanel')">
          <icon :type="'save'"/>
        </div>
      </div>
      <user-idp-setter
          v-if="authMethod && hasSuperPerms"
          :user-auth-method="authMethod"
          :user-id="userId"
          class="mt-2"
      />
    </div>
    <div class="col-12 col-lg-7 col-xxl-7">
      <h2 class="d-inline-block">{{ $t('organizations') }}</h2>
      <loading-spinner :class="['ml-2 d-inline-block', !organizationLoading ? 'invisible' : '']"/>
    <div class="w-100" />
      <div class="d-flex mb-2">
        <input
            v-model="orgSearchString"
            :placeholder="$t('searchOrgs')"
            class="form-text form-text-dark col-6"
            type="text"
        />
        <universal-selector
            v-if="editAllUserData || $store.getters.isSuperAdmin"
            :exclude-from-item-list="Object.values(organizations)"
            :select-placeholder="$t('addOrg')"
            :tag-condition="{
                      fieldName: 'visibility',
                      '0': 'user',
                    }"
            class="col-6 pr-0"
            filter-attribute="displayName"
            list-name="userOrgList"
            store-name="Organization"
            @addItem="addItemUser"
        />
      </div>

        <user-organization
            v-for="org in filteredOrganizations"
            v-if="!initialOrganizationLoading && filteredOrganizations"
            :key="org.id"
            :highlight-items="freshAddedItems"
            :organization="org"
            :show-teams="true"
            :user-id="userId"
            :fresh-added-items="freshAddedItems"
            class="mb-2"
            @addTeam="(item) => addItemUser(item, 'Team')"
            @removeOrganization="removeItemUser({id: org.id, type: 'Organization'})"
            @removeTeam="(args) => {removeItemUser({...args, type: 'Team'})}"
            @setDefault="(id) => {updateItemUser(id, {default: true}, 'Organization')}"
            @setDefaultTeam="(teamId, isDefault) => {updateItemUser(teamId, {default: isDefault}, 'Team')}"
            @updateAppPanel="(organizationId, appPanel) => {updateItemUser(organizationId, {appPanel}, 'Organization')}"
            @updateOrganizationRole="(orgId, role) => {updateItemUser(orgId, {role}, 'Organization')}"
            @updateTeamRole="(teamId, role) => {updateItemUser(teamId, {role}, 'Team')}"
        />
        <div v-if="!organizationLoading && !Object.keys(filteredOrganizations).length" class="lighter mt-2">
          {{ $t('noOrgs') }}
        </div>

      <div v-if="$store.getters.isSuperAdmin" class="mb-2 mt-5 vform-label white bigger">{{ $t('licenses') }}</div>
      <info-panel
          v-if="$store.getters.isSuperAdmin"
          :collapsible="true"
          :initially-collapsed="false"
          info-panel-header="licenses"
          preview-id="noneNone"
      >
        <div slot="info" class="container-fluid no-gutters">
          <licenses :user-id="userId"/>
        </div>
      </info-panel>
    </div>
  </div>
</template>

<script>
import {required, minLength, email, sameAs} from 'vuelidate/lib/validators'
import Icon from "../Icon";
import LabelWithEditIconAndContent from "../LabelWithEditIconAndContent";
import UniversalSelector from "../organizations/UniversalSelector";
import ContentTitleBlock from "../ContentTitleBlock";
import InfoPanel from "@/components/InfoPanel";
import {AdminData} from "@/enum";
import PasswordChecker from "@/components/forms/PasswordChecker";
import Licenses from "../Licenses";
import ErrorMixinJs from "../mixins/ErrorMixin.js";
import UserIdpSetter from "@/components/UserIdpSetter.vue";
import UserOrganization from "@/components/forms/UserOrganization.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Vue from "vue";
export default {
  name: "UserEditForm",
  components: {
    UserOrganization,
    Icon,
    LabelWithEditIconAndContent,
    UniversalSelector,
    ContentTitleBlock,
    InfoPanel,
    PasswordChecker,
    Licenses,
    UserIdpSetter,
    LoadingSpinner
  },
  mixins: [ErrorMixinJs],
  props: {
    userId: {type: String, default: null},
    hasSuperPerms: {type: Boolean, default: false}
  },
  data() {
    return {
      organizationLoading: false,
      initialOrganizationLoading: true,
      orgSearchString: '',
      blocked: 0,
      showPassword: false,
      AdminData: AdminData,
      appPanel: '',
      editAllUserData: false,
      fieldEditing: '',
      enableSaving: false,
      name: '',
      firstName: '',
      lastName: '',
      email: '',
      //oldPassword: '',
      password: '',
      password2: '',
      error: '',
      role: '',
      organizations: {},
      teams: {},
      defaultTeamId: '',
      forceReRenderKey: 0,
      licenses: [],
      homeOrganizationId: '',
      authMethod: null,
      freshAddedItems: [],
    };
  },
  computed: {
    filteredOrganizations() {
      let targetOrgs = {};
      if (this.orgSearchString && this.orgSearchString.length > 0) {
        const orgs = JSON.parse(JSON.stringify(this.organizations));
        const keys = Object.keys(orgs);
        for (let i = 0; i < keys.length; i++) {
          const org = orgs[keys[i]];
          if (org.displayName.toLowerCase().includes(this.orgSearchString.toLowerCase())) {
            targetOrgs[org.id] = org;
          }
        }
        return targetOrgs;
      }
      return this.organizations;
    }
  },
  mounted() {
    this.init();
  },
  validations: {
    name: {
      required,
      minLength: minLength(3),
      async isUnique(value) {
        // standalone validator ideally should not assume a field is required
        if (value === '') {
          return true;
        }
        let bool = true;
        await this.$store.dispatch('checkIfUserNameExists', {name: value, type: 'User', value: value}).then(data => {
          if (data.length > 0 && data[0]) {
            if (data[0].id === this.userId) {
              bool = true;
            }
          } else {
            bool = data.length === 0;
          }
        });
        return bool;
      }
    },
    firstName: {
      required,
      minLength: minLength(3)
    },
    lastName: {
      required,
      minLength: minLength(3)
    },
    email: {
      required,
      email,
      async isUnique(value) {
        if (value === '') {
          return true;
        }
        let bool = true;
        await this.$store.dispatch('checkIfUserEmailExists', value).then(data => {
          if (data.length > 0 && data[0]) {
            if (data[0].id === this.userId) {
              bool = true;
            }
          } else {
            bool = data.length === 0;
          }
        });
        return bool;
      }
    },
    /*oldPassword: {
      required
    },*/
    password: {
      required,
      minLength: minLength(6)
    },
    password2: {
      required,
      sameAsPassword: sameAs('password')
    },
  },
  methods: {
    async init() {
      await Promise.all([
        this.loadUser(),
        this.loadUserOrganizations(),
      ]);
    },
    async loadUser() {
      let listName = 'userList';
      if (this.userId === this.$store.getters.getCurrentUserId) {
        listName = 'globalUser';
      }
      await this.$store.dispatch('loadUser', {
        id: this.userId,
        listName: listName
      }).then(async data => {
        if (data) {
          if (!this.$store.getters.isSuperAdmin && !this.$store.getters.isSFXMember) {
            this.$emit('checkPermission', data.homeOrganizationId);
          }
          this.homeOrganizationId = data.homeOrganizationId;
          this.setData(data);
        } else {
          this.$emit('userNotFound');
        }
      });
    },
    async loadUserTeams() {
      return await this.$store.dispatch('clientLoadUserTeams', {
        id: this.userId,
      })
    },
    async loadUserOrganizations() {
      this.organizationLoading = true;
      await this.$store.dispatch('clientLoadUserOrganizations', {
        id: this.userId,
        include: ['requiredUser'],
        sort: '+displayName',
      }).then(async data => {
        const teams = await this.loadUserTeams();
        for(let i = 0; i < data.length; i++) {
          const tmpTeams = teams.filter(team => {
            return team.organizationId === data[i].id;
          });
          data[i].teams = this.sortFreshAddedItemsTop(tmpTeams);
        }
        data = this.sortFreshAddedItemsTop(data);
        this.updateUserOrganizationsFromData(data);
        this.organizationLoading = false;
        this.initialOrganizationLoading = false;
      })
    },
    updateUserOrganizationsFromData(data) {
      this.organizations = {};
      if (data && data.length) {
        for (let i = 0; i < data.length; i++) {
          Vue.set(this.organizations, data[i].id, data[i]);
        }
      }
      const keys = Object.keys(this.organizations);
      if(keys.length) {
        for(let i = 0; i < keys.length; i++) {
          const org = this.organizations[keys[i]];
          if(!data.some(item => item.id === org.id)) {
            Vue.delete(this.organizations, keys[i]);
          }
        }
      }
    },
    sortFreshAddedItemsTop(data) {
      if (this.freshAddedItems && this.freshAddedItems.length) {
        console.log('sorting fresh added items to top');
        const freshAdded = this.freshAddedItems.map(id => {
          return data.find(item => item.id === id);
        }).filter(item => item);
        const rest = data.filter(item => !this.freshAddedItems.includes(item.id));
        const restByAlphabet = rest.sort((a, b) => {
          return a.displayName.localeCompare(b.displayName);
        });
        return [...freshAdded, ...restByAlphabet];
      }
      return data;
    },
    /**
     * Copies data from query result to local data of the userEditForm component
     * */
    setData(data) {
      const disattachedData = JSON.parse(JSON.stringify(data));
      Object.keys(disattachedData).map(key => {
        if(key !== 'organizations') {
          this[key] = disattachedData[key];
        }
      })
    },
    /**
     * Sets a field to editing
     * */
    setEditing(fieldName) {
      this.fieldEditing = fieldName;
    },
    /**
     * Checks whether a field is editing
     * */
    isEditing(fieldName) {
      return this.fieldEditing === fieldName;
    },
    /**
     * Cancels editing
     * */
    cancelEditing() {
      this.fieldEditing = '';
      this.loadUser();
    },
    /***
     * Removes a user from either an organization or a team
     * @params {object} obj - the user object
     * @params {string} type - either 'Organization' or 'Team'
     * */
    removeItemUser(args) {
      const {id, type} = args;
      this.freshAddedItems = this.freshAddedItems.filter(item => item !== id);
      this.$store.dispatch(`clientRemove${type}Member`, {
            id,
            cid: this.userId,
            args: [this.userId],
          }
      ).then(() => {
        this.init();
      });
    },
    addOrganizationUser(org) {
      let args = {
        userId: this.id,
        role: org.id !== this.AdminData.vHubOrganizationId ? 'none' : 'viewer',
      };
      this.$store.dispatch(`clientAddOrganizationMember`, {
            id: org.id,
            cid: this.id,
            args: [args]
          }
      ).then(() => {
        this.init();
        this.$store.dispatch('createNotification', {
          text: this.$t('userRemoved')
        });
      });
    },
    /***
     * Adds a user to either an organization or a team
     * @params {object} obj - the user object
     * @params {string} type - either 'Organization' or 'Team'
     * */
    async addItemUser(org, type = 'Organization') {
      this.freshAddedItems.push(org.id);
      let args = {};
      if(type === 'Organization') {
        args = [{
          userId: this.id,
          role: org.id !== this.AdminData.vHubOrganizationId ? 'none' : 'viewer',
        }];
      } else {
        args = {
          userId: this.id,
          role: 'viewer',
        };
      }
      return this.$store.dispatch(`clientAdd${type}Member`, {
            id: org.id,
            cid: this.id,
            args
          }
      ).then(() => {
        return this.init();
      });
    },
    /***
     * Updates a user relationship to either an organization or a team
     * @params {string} organizationId - the id of the organization concerning this
     * @params {object} obj - the membership object containing e.g. the role
     * @params {string} type - either 'Organization' or 'Team'
     * */
    async updateItemUser(organizationId, memberObject, type = 'Organization') {
      console.log('updating item', organizationId, memberObject, type);
      await this.$store.dispatch(`clientUpdate${type}Member`, {
            id: organizationId,
            cid: this.userId,
            ...memberObject
          }
      ).then(async () => {
        await this.init();
        this.forceReRenderKey++;
        this.$store.dispatch('createNotification', {
          text: this.$t('userUpdated')
        });
      });
    },
    async updateUser(fieldName) {
      this.error = '';
      if (!this.$v.$anyError) {
        let args = {
          [fieldName]: this[fieldName],
          id: this.userId
        };
        /*if (fieldName === 'password') {
          args.oldPassword = this.oldPassword;
        }*/
        await this.$store.dispatch('updateUser', args)
            .then(() => {
              this.cancelEditing();
            })
            .catch(e => {
              this.error = this.getErrorContent(e);
            });

      }
    },
  },
}
</script>